import React, { useState } from "react";

import axios from "axios";

import {
  Link,
  useNavigate
} from "react-router-dom";

import Header from "../components/Header";

import config from "../config";

const API =
  `${config.API_BASE_URL}/api/auth/register`;

const Register = () => {

  const navigate =
    useNavigate();

  // =========================
  // STATES
  // =========================

  const [name, setName] =
    useState("");

  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [showPassword, setShowPassword] =
    useState(false);

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  // =========================
  // REGISTER
  // =========================

  const handleRegister =
    async (e) => {

    e.preventDefault();

    setError("");

    try {

      setLoading(true);

      const res =
        await axios.post(
          API,
          {
            name,
            email,
            password
          }
        );

      alert(
        res.data.message ||
        "Registration successful"
      );

      navigate("/login");

    } catch (err) {

      console.error(
        "REGISTER ERROR:",
        err
      );

      setError(
        err.response?.data?.message ||
        "Registration failed"
      );

    } finally {

      setLoading(false);
    }
  };

  return (

    <div style={styles.page}>

      <Header />

      <div style={styles.container}>

        <div style={styles.card}>

          <h1 style={styles.title}>
            ✨ Create Account
          </h1>

          <p style={styles.subtitle}>
            Join Tuli Store today
          </p>

          {error && (

            <div style={styles.error}>
              {error}
            </div>

          )}

          <form
            onSubmit={
              handleRegister
            }
          >

            {/* NAME */}

            <div style={styles.field}>

              <label style={styles.label}>
                Full Name
              </label>

              <input
                type="text"
                value={name}
                onChange={(e) =>
                  setName(
                    e.target.value
                  )
                }
                required
                placeholder="Enter full name"
                style={styles.input}
              />

            </div>

            {/* EMAIL */}

            <div style={styles.field}>

              <label style={styles.label}>
                Email Address
              </label>

              <input
                type="email"
                value={email}
                onChange={(e) =>
                  setEmail(
                    e.target.value
                  )
                }
                required
                placeholder="Enter email"
                style={styles.input}
              />

            </div>

            {/* PASSWORD */}

            <div style={styles.field}>

              <label style={styles.label}>
                Password
              </label>

              <div style={styles.passwordWrap}>

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  value={password}
                  onChange={(e) =>
                    setPassword(
                      e.target.value
                    )
                  }
                  required
                  placeholder="Enter password"
                  style={styles.passwordInput}
                />

                <button
                  type="button"
                  style={styles.showBtn}
                  onClick={() =>
                    setShowPassword(
                      !showPassword
                    )
                  }
                >
                  {showPassword
                    ? "🙈"
                    : "👁"}
                </button>

              </div>

            </div>

            {/* BUTTON */}

            <button
              type="submit"
              disabled={loading}
              style={styles.button}
            >

              {loading
                ? "Creating..."
                : "Create Account"}

            </button>

          </form>

          {/* LOGIN */}

          <div style={styles.footer}>

            Already have an account?

            <Link
              to="/login"
              style={styles.link}
            >
              Login
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Register;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(to right, #fff7e6, #ffe0cc)"
  },

  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    minHeight:
      "calc(100vh - 90px)"
  },

  card: {
    width: "100%",
    maxWidth: 430,
    background: "#fff",
    padding: 35,
    borderRadius: 20,
    boxShadow:
      "0 8px 25px rgba(0,0,0,0.1)"
  },

  title: {
    margin: 0,
    textAlign: "center",
    fontSize: 32,
    color: "#222"
  },

  subtitle: {
    textAlign: "center",
    color: "#666",
    marginTop: 10,
    marginBottom: 25
  },

  field: {
    marginBottom: 20
  },

  label: {
    display: "block",
    marginBottom: 8,
    fontWeight: "bold",
    color: "#333"
  },

  input: {
    width: "100%",
    padding: 14,
    border:
      "1px solid #ddd",
    borderRadius: 10,
    fontSize: 15,
    outline: "none",
    boxSizing: "border-box"
  },

  passwordWrap: {
    display: "flex",
    alignItems: "center",
    border:
      "1px solid #ddd",
    borderRadius: 10,
    overflow: "hidden",
    background: "#fff"
  },

  passwordInput: {
    flex: 1,
    padding: 14,
    border: "none",
    outline: "none",
    fontSize: 15
  },

  showBtn: {
    border: "none",
    background: "#fff",
    cursor: "pointer",
    padding: "0 14px",
    fontSize: 18
  },

  button: {
    width: "100%",
    padding: 14,
    border: "none",
    borderRadius: 10,
    background: "#ff9800",
    color: "#fff",
    fontWeight: "bold",
    fontSize: 16,
    cursor: "pointer",
    marginTop: 5
  },

  error: {
    background: "#ffe5e5",
    color: "#d8000c",
    padding: 12,
    borderRadius: 10,
    marginBottom: 20,
    fontSize: 14
  },

  footer: {
    marginTop: 25,
    textAlign: "center",
    color: "#555"
  },

  link: {
    marginLeft: 6,
    color: "#ff5722",
    fontWeight: "bold",
    textDecoration: "none"
  }
};